
module Meevo.Plugins.Register {
    "use strict";

    export class TipModalContext extends ModalContextBase {
        currentTip: number;
        changeDue: number;
        changeRemaining: number;
        totalTipFromDevice: number = 0;
        totalTipPercentageFromDevice: number = 0;
        totalServiceFromDevice: number = 0;
        totalInternalTipFromPrepaid: number = 0;
        totalExternalTipFromPrepaid: number = 0;
        tipLines: RegisterTipLine[];
        refundTipLines: Model.TipLine[] = [];
        sale: Model.Sale;
        useDiscountedPrice: boolean = true;
        hasDiscount: boolean;
        excludedEmployees: any[];
        ticketPercentage: number;
        ticketPercentageChanged: boolean;
        ticketAmount: number;
        ticketAmountChanged: boolean;
        tipLineChanged: boolean;
        needToApplyTip: boolean = false;
        specificTip: boolean = false;
        isPercentageSymbol: boolean = true;
        showNewEmp: boolean = false;
        currencySymbol: string;
        filterMeevoCurrency: any;

        defaultTipType = Model.TipAmountTypeEnum.Percentage;
        percentageTipValues: number[] = [10, 15, 18, 20, 25];
        amountTipValues: number[] = [1, 5, 10, 20, 50];

        get $translate() { return this.parent.$translate; }
        get registerTipService() { return this.parent.registerTipService; }
        get modalService() { return this.parent.modalService; }
        get disabledTipLines() { return [...this.refundTipLines, ...this.externalTipLines] }
        get nonRefundTipLines() { return [...this.tipLines, ...this.externalTipLines] }
        get totalTipFromPrepaid() { return this.totalInternalTipFromPrepaid + this.totalExternalTipFromPrepaid; }

        externalTipLines: Model.TipLine[] = [];
        externalMappedEmployeeIds: { id: string }[] = undefined;
        showDeleteIconForHouse: boolean = false;

        constructor(protected parent: ModalController) {
            super(parent);

            this.isPercentageSymbol = (parent.registerContext.defaultTipType === Model.TipAmountTypeEnum.Percentage);
            this.currencySymbol = this.parent.$locale.NUMBER_FORMATS.CURRENCY_SYM;
            this.filterMeevoCurrency = this.parent.$filter('meevoCurrency') as any;

            if (parent.registerContext.percentageTipValues && parent.registerContext.percentageTipValues.length > 0) {
                this.percentageTipValues = _.chain(parent.registerContext.percentageTipValues).map((item) => this.normalizeDecimalPlaces(Number(item) * 100)).sortBy(i => i).value();
            }

            if (parent.registerContext.amountTipValues && parent.registerContext.amountTipValues.length > 0) {
                this.amountTipValues = _(parent.registerContext.amountTipValues).sortBy(i => Number(i));
            }
        }

        private updateServiceTotals(tipLine, saleLine: Model.SaleLine, employeeId, includeProductsInTips: boolean) {
            this.registerTipService.updateServiceTotals(this.parent.registerContext, this.sale, tipLine, saleLine, employeeId, includeProductsInTips);
        }

        private loadTipChangeDueEditor() {
            _(this.sale.tipLines).forEach((tipLine) => this.setNullEmployeeToHouseEmployeeInTipLine(tipLine));

            this.registerTipService.pruneMissingEmployees(this.sale, this.parent.registerContext.HouseEmployee);

            const tipLines = _(this.sale.tipLines).where({ isRefund: false });

            _(tipLines).forEach((tipLine: RegisterTipLine) => {
                if (!tipLine.employee.allowTips) {
                    return;
                }

                tipLine.baseTotal = 0;
                tipLine.finalTotal = 0;

                let isServiceEmployee = false;

                // see if tipLine employee has corresponding saleLine item(s)
                const existingEmployee = _(this.sale.saleLines).any((saleLine) => saleLine.employeeId === tipLine.employeeId);

                if (existingEmployee) {
                    const existingSaleLines = _(this.sale.saleLines).filter((saleLine) =>
                        saleLine.employeeId === tipLine.employeeId &&
                        saleLine.saleType === Model.SalesTypeEnum.Service);

                    if (existingSaleLines && existingSaleLines.length > 0) {
                        isServiceEmployee = true;
                        _(existingSaleLines).forEach((saleLine) => {
                            this.updateServiceTotals(tipLine, saleLine, saleLine.employeeId, this.parent.registerContext.includeProductsInTips);
                        });
                    }
                }

                const existingSecondEmployee = _(this.sale.saleLines).any((saleLine) => saleLine.secondEmployeeId === tipLine.employeeId);

                if (existingSecondEmployee) {
                    const existingSaleLines = _(this.sale.saleLines).filter((saleLine) =>
                        saleLine.secondEmployeeId === tipLine.employeeId &&
                        saleLine.saleType === Model.SalesTypeEnum.Service);

                    if (existingSaleLines && existingSaleLines.length > 0) {
                        isServiceEmployee = true;
                        _(existingSaleLines).forEach((saleLine) => {
                            this.updateServiceTotals(tipLine, saleLine, saleLine.secondEmployeeId, this.parent.registerContext.includeProductsInTips);
                        });
                    }
                }

                this.addTipLine(
                    tipLine.employeeId,
                    tipLine.employee,
                    tipLine.originalEmployeeId,
                    tipLine.originalEmployee,
                    tipLine.amount,
                    tipLine.percentage,
                    tipLine.baseTotal,
                    tipLine.finalTotal,
                    isServiceEmployee,
                    tipLine.externalTipTransactionId);
            });

            this.showDeleteIconForHouse = !this.tipLines.find(tipLine => tipLine.employee === this.parent.registerContext.HouseEmployee) && this.externalTipLines.length > 0;
            var addlTipLines: RegisterTipLine[] = [];

            for (const saleLine of this.sale.saleLines) {
                if (saleLine.saleType !== Model.SalesTypeEnum.Service || saleLine.isRefund) {
                    continue;
                }

                // do not offer an employee for a service that does not collect tips.
                // existing saved tip lines are still loaded above and left untouched.
                if (saleLine.item && (<any>saleLine.item).doNotAllowTips) {
                    continue;
                }

                // if it already exists in the tipLines, then ignore
                const existingTipLine = _(this.nonRefundTipLines).any(tipLine => tipLine.employeeId === saleLine.employeeId || tipLine.employeeId === saleLine.secondEmployeeId);
                if (existingTipLine) {
                    continue;
                }

                const houseEmployee = this.parent.registerContext.HouseEmployee;
                const includeProductsInTips = this.parent.registerContext.includeProductsInTips;

                // if it does not already exist in the tipLines, then add to temp array for adding to main array later
                if (saleLine.employeeId) {
                    if (!saleLine.employee.id) {
                        saleLine.employee.id = saleLine.employeeId;
                    }

                    let employee = saleLine.employee.allowTips ? saleLine.employee : houseEmployee;
                    let employeeId = employee.id;

                    let existingAddlTipLine = _(addlTipLines).findWhere({ employeeId: employeeId, originalEmployeeId: saleLine.employeeId });

                    if (!existingAddlTipLine) {
                        existingAddlTipLine = this.registerTipService.getTipLine(this.parent.registerContext, employeeId, employee, saleLine.employeeId, saleLine.employee, 0, 0, 0, 0, true);
                        addlTipLines.push(existingAddlTipLine);
                    }

                    this.updateServiceTotals(existingAddlTipLine, saleLine, saleLine.employeeId, includeProductsInTips);
                }

                if (saleLine.secondEmployeeId) {
                    if (!saleLine.secondEmployee.id) {
                        saleLine.secondEmployee.id = saleLine.secondEmployeeId;
                    }

                    let employee = saleLine.secondEmployee.allowTips ? saleLine.secondEmployee : houseEmployee;
                    let employeeId = employee.id;

                    let existingAddlTipLine = _(addlTipLines).findWhere({ employeeId: employeeId, originalEmployeeId: saleLine.secondEmployeeId });
                    if (!existingAddlTipLine) {
                        existingAddlTipLine = this.registerTipService.getTipLine(this.parent.registerContext, employeeId, employee, saleLine.employeeId, saleLine.employee, 0, 0, 0, 0, true);
                        addlTipLines.push(existingAddlTipLine);
                    }

                    this.updateServiceTotals(existingAddlTipLine, saleLine, saleLine.secondEmployeeId, includeProductsInTips);
                }

                this.setNullEmployeeToHouseEmployeeInSaleLine(saleLine);
            }

            if (addlTipLines.length > 0) {
                this.tipLines.push(...addlTipLines);
            }

            this.refundTipLines = _(this.sale.tipLines).where({ isRefund: true });
            this.currentTip = this.getSaleEditableTip();
            this.refreshTips();
        }

        private loadTip() {
            _(this.sale.tipLines).forEach((tipLine) => this.setNullEmployeeToHouseEmployeeInTipLine(tipLine));

            this.registerTipService.pruneMissingEmployees(this.sale, this.parent.registerContext.HouseEmployee);

            this.registerTipService.generateTipEmployeeLines(this.parent.registerContext, this.sale, this.tipLines, this.parent.registerContext.includeProductsInTips);

            _(this.sale.saleLines).forEach((saleLine) => this.setNullEmployeeToHouseEmployeeInSaleLine(saleLine));

            // add non-service employees
            const tipLines = _(this.sale.tipLines).where({ isRefund: false });

            for (const tipLine of tipLines) {
                if (_(this.tipLines).findWhere({ employeeId: tipLine.employeeId, originalEmployeeId: tipLine.originalEmployeeId })) {
                    continue;
                }

                this.addTipLine(
                    tipLine.employeeId,
                    tipLine.employee,
                    tipLine.originalEmployeeId,
                    tipLine.originalEmployee,
                    this.normalizeDecimalPlaces(tipLine.amount)
                );
            }

            this.refundTipLines = _(this.sale.tipLines).where({ isRefund: true });
            this.currentTip = this.getSaleEditableTip();
            this.refreshTips();
        }

        load(sale: Model.Sale) {
            this.sale = angular.copy(sale);
            this.tipLines = [];

            this.useDiscountedPrice = (this.sale.useDiscountedPrice === undefined)
                ? this.parent.registerContext.defaultTipCalculationsDiscountedPrice
                : this.sale.useDiscountedPrice;

            switch (this.parent.modalType) {
                case RegisterModalTypeEnum.TipChangeDueTransactionEditor:
                    this.loadTipChangeDueEditor();
                    break;

                case RegisterModalTypeEnum.Tip:
                case RegisterModalTypeEnum.TipCardOnFile:
                case RegisterModalTypeEnum.TipCreditCard:
                    this.loadTip();
                    break;

                default:
                    this.loadTip();
                    break;
            }

            this.buildExternalTipFromPrepaid();
            this.buildTotalTipFromDevice();
            this.buildTotalTipFromPrepaid();

            // Must run after buildTotalTipFromPrepaid so prepaid tip minimums are known.
            // Excluded for the Transaction Editor: that modal operates on a completed transaction,
            // and dropping a saved tip line there would fail SaleLogic.UpdateAsync validation
            // (MESSAGE_TRANSACTION_EDITOR_TIPPY_TIP_CHANGED).  Non-tippable employees are instead
            // never added in loadTipChangeDueEditor.
            if (this.parent.modalType !== RegisterModalTypeEnum.TipChangeDueTransactionEditor) {
                this.registerTipService.pruneNonTippableEmployees(this.sale, this.tipLines);
            }

            this.changeDue = this.normalizeDecimalPlaces(this.sale.changeDue + (this.sale.tip + this.sale.tipRefund) - this.sale.totalPrepaidTipRedeemed);
            this.changeRemaining = this.sale.changeDue;
            this.currentTip = this.getSaleEditableTip();

            if (sale.tipPercentage) {
                this.isPercentageSymbol = true;
                this.applyTipPercentage(sale.tipPercentage);
                this.setTicketAmount(sale.tipAmount);
            }
            else if (sale.tipAmount) {
                this.isPercentageSymbol = false;
                this.applyTipAmount(sale.tipAmount);
                this.setTicketPercentage(sale.tipPercentage);
            }

            this.buildExcludedEmployeeIds();

            this.hasDiscount = this.isSaleDiscounted(this.sale);
        }

        private buildExternalTipFromPrepaid() {
            this.totalExternalTipFromPrepaid = 0;

            for (var externalTipLine of this.externalTipLines) {
                var saleLines = this.parent.registerContext.sale.saleLines.filter(saleLine => saleLine.employeeId === externalTipLine.employeeId);
                this.totalExternalTipFromPrepaid = this.normalizeDecimalPlaces(this.totalExternalTipFromPrepaid +
                    saleLines.reduce((total, next) => total += next.prepaidTipRedeemed, 0));
            }
        }

        private setTicketPercentage(percent: number) {
            this.ticketPercentage = percent;
        }

        private setTicketAmount(amount: number) {
            this.ticketAmount = amount === null || amount === undefined
                ? amount
                : this.normalizeDecimalPlaces(amount);
        }

        private buildTotalTipFromDevice() {
            this.totalTipFromDevice = this.parent.registerContext.getTotalTipFromDevice();
            this.totalTipPercentageFromDevice = this.parent.registerContext.getTotalTipPercentageFromDevice();
            this.totalServiceFromDevice = this.parent.registerContext.getServiceTotalFromDevice();
        }

        private buildTotalTipFromPrepaid() {
            const totalPrepaidTip = this.parent.registerContext.getTotalTipFromPrepaid();
            if (!totalPrepaidTip) {
                return;
            }

            this.totalInternalTipFromPrepaid = totalPrepaidTip - this.totalExternalTipFromPrepaid;
            this.registerTipService.calculatePrepaidTipMinimums(this.parent.registerContext, this.nonRefundTipLines, this.parent.registerContext.sale.saleLines);
        }

        private addTipLine(
            employeeId: string,
            employee: Model.EmployeeListItem,
            originalEmployeeId: string,
            originalEmployee: Model.EmployeeListItem,
            amount: number = 0,
            percentage: number = null,
            baseTotal: number = 0,
            finalTotal: number = 0,
            isServiceEmployee: boolean = false,
            externalTipTransactionId: string = undefined
        ): RegisterTipLine {
            const tipLine = this.registerTipService.addTipLine(
                this.parent.registerContext,
                externalTipTransactionId ? this.externalTipLines : this.tipLines,
                employeeId,
                employee,
                originalEmployeeId,
                originalEmployee,
                amount,
                percentage,
                baseTotal,
                finalTotal,
                isServiceEmployee);
            tipLine.externalTipTransactionId = externalTipTransactionId;

            return tipLine;
        }

        private buildExcludedEmployeeIds() {
            const excludedEmployees = _(this.tipLines).map((tipLine: RegisterTipLine) => {
                if (!tipLine.employee) {
                    return null;
                }

                if (tipLine.employeeId === Guid.empty.toString()) {
                    tipLine.employee.id = tipLine.employeeId;
                }

                return tipLine.employee;
            });

            if (this.parent.modalType === RegisterModalTypeEnum.TipChangeDueTransactionEditor && !this.externalMappedEmployeeIds) {
                let unauthorizedConfig: Meevo.Plugins.Tippy.IUnauthorizedConfig = {
                    additionalMessage: "MESSAGE_TIPPY_UNAUTHORIZED_TRANS_EDITOR_CHANGE_DUE"
                }
                this.parent.registerContext.tippyService.getTippyEmployeeMappings(unauthorizedConfig).then(mappings => {
                    this.externalMappedEmployeeIds = _(mappings).pluck('meevoEmployeeId').map(id => { return { id } });
                    this.excludedEmployees = [...excludedEmployees, ...(this.externalMappedEmployeeIds || [])];
                });
                return;
            }

            this.excludedEmployees = [...excludedEmployees, ...(this.externalMappedEmployeeIds || [])];
        }

        private distributeTip(tipAmount: number) {
            const serviceTotal = this.getServiceTotal(this.useDiscountedPrice);

            if (this.tipLines.length === 0) {
                if (serviceTotal > 0) {
                    this.tipLineChanged = false;
                }
            }

            const totalExternalTip = this.getTotalExternalTip();
            const totalIrreducibleTip = this.normalizeDecimalPlaces(this.totalInternalTipFromPrepaid + totalExternalTip - this.totalExternalTipFromPrepaid);
            tipAmount = Math.max(tipAmount, totalIrreducibleTip);

            if (tipAmount > 0) {
                this.registerTipService.distributeTipIntoTipLines(this.parent.registerContext, this.tipLines, tipAmount, totalExternalTip);
            }
        }

        private refreshTips(): ng.IPromise<void> {
            let ticketAmountChanged = this.ticketAmountChanged;

            _(this.tipLines).forEach((tipLine) => {
                tipLine.serviceTotal = this.registerTipService.calculateServicePrice(tipLine.baseTotal, tipLine.finalTotal, this.useDiscountedPrice);
            });

            return this.registerTipService.refreshTips(this.parent.registerContext, this.tipLines).then((currentTip: number) => {
                const lastTipLine = _(this.tipLines).last();

                this.currentTip = this.parent.registerContext.addNormalizedNumbers(currentTip, this.getTipTotal(this.externalTipLines));

                if (ticketAmountChanged && lastTipLine && this.ticketAmount) {
                    const roundingError = this.normalizeDecimalPlaces(this.ticketAmount - this.currentTip);
                    if (roundingError !== 0) {
                        lastTipLine.amount = this.parent.registerContext.addNormalizedNumbers(lastTipLine.amount, roundingError);
                        currentTip = this.ticketAmount;
                    }
                }

                this.tipLineChanged = false;
                this.changeRemaining = this.parent.registerContext.subtractNormalizedNumbers(this.parent.registerContext.addNormalizedNumbers(this.sale.changeDue, this.sale.tip + this.sale.tipRefund), this.currentTip);

                if (this.needToApplyTip) {
                    this.applyTip();
                }
            });
        }

        updateSaleTipState(updateRegisterTip: boolean = false, isTippy = false) {
            this.sale.tipAmount = this.ticketAmount;
            this.sale.tipPercentage = this.ticketPercentage;
            this.sale.useDiscountedPrice = this.useDiscountedPrice;
            this.sale.tipLines = [];

            _(this.nonRefundTipLines).forEach((tipLine: RegisterTipLine) => {
                if (tipLine.employeeId && (!tipLine.isServiceEmployee || (tipLine.isServiceEmployee && tipLine.amount > 0 || isTippy))) {
                    const saleTipLine = {
                        employeeId: tipLine.employeeId,
                        employee: tipLine.employee,
                        originalEmployeeId: tipLine.originalEmployeeId,
                        originalEmployee: tipLine.originalEmployee,
                        amount: tipLine.amount,
                        percentage: tipLine.percentage,
                        isRefund: false,
                        isServiceEmployee: tipLine.isServiceEmployee,
                        serviceTotal: tipLine.serviceTotal,
                        prepaidTipMinimum: tipLine.prepaidTipMinimum,
                        externalTipTransactionId: tipLine.externalTipTransactionId
                    } as Model.TipLine;
                    this.sale.tipLines.push(saleTipLine);
                }
            });

            _(this.refundTipLines).forEach((tipLine: Model.TipLine) => {
                this.sale.tipLines.push(tipLine);
            });

            if (updateRegisterTip && this.parent.registerContext) {
                this.parent.registerContext.updateTip(
                    this.sale.tipLines,
                    this.sale.tipPercentage,
                    this.sale.tipAmount,
                    this.sale.useDiscountedPrice
                );

                if (this.parent.registerContext.selectedSection &&
                    this.parent.registerContext.selectedSection.sectionType === Register.RegisterSectionTypeEnum.Tips) {
                    this.parent.registerContext.selectedSection.reset();
                }
                this.parent.registerContext.tippyService.partialRefundTransaction(this.parent.registerContext);
            }
            return this.sale.tipLines;
        }

        private showToast(messageId) {
            const toast = this.parent.$mdToast.simple();
            toast.theme("error-toast");
            toast.textContent(this.parent.$translate.instant(messageId));
            toast.position("bottom right");
            toast.parent(angular.element(".checkout-modal-overalay"));
            toast.hideDelay(4000);
            this.parent.$mdToast.show(toast);
        }

        private getSaleEditableTip() {
            const tipLines = [..._(this.sale.tipLines).where({ isRefund: false }), ...this.sale.tipLines.filter(tipLine => !tipLine.externalTipTransactionId)];

            return this.getTipTotal(tipLines);
        }

        private getTipTotal(tipLines: Model.TipLine[]): number {
            let tip = 0;
            _(tipLines).forEach(tipLine => {
                tip = this.parent.registerContext.addNormalizedNumbers(tip, tipLine.amount);
            });

            return tip;
        }

        private setNullEmployeeToHouseEmployeeInTipLine(tipLine: Model.TipLine) {
            if (!tipLine.employeeId) {
                tipLine.employee = this.parent.registerContext.HouseEmployee;
                tipLine.employeeId = this.parent.registerContext.HouseEmployee.id;
            }
            if (!tipLine.originalEmployeeId) {
                tipLine.originalEmployee = this.parent.registerContext.HouseEmployee;
                tipLine.originalEmployeeId = this.parent.registerContext.HouseEmployee.id;
            }
        }

        private setNullEmployeeToHouseEmployeeInSaleLine(saleLine: Model.SaleLine) {
            if (!saleLine.employeeId) {
                saleLine.employee = this.parent.registerContext.HouseEmployee;
                saleLine.employeeId = this.parent.registerContext.HouseEmployee.id;
            }
            if (!saleLine.secondEmployeeId && saleLine.secondEmployeeSplitCommission != undefined) {
                saleLine.secondEmployee = this.parent.registerContext.HouseEmployee;
                saleLine.secondEmployeeId = this.parent.registerContext.HouseEmployee.id;
            }
        }

        private checkMinimumTips(newAmount: number = 0): boolean {
            let tipTypes = '';
            const totalExternalTip = this.getTotalExternalTip();
            let totalMinimumTip = this.normalizeDecimalPlaces(this.totalInternalTipFromPrepaid + totalExternalTip);

            if (newAmount >= totalMinimumTip) {
                return true;
            }

            const formattedTotalMinimumTip = this.filterMeevoCurrency(totalMinimumTip);

            if (this.totalTipFromPrepaid) {
                tipTypes = 'prepaid'
            }

            if (totalExternalTip) {
                tipTypes += tipTypes ? ' & MeevoTips' : 'MeevoTips';
            }

            if (!tipTypes) {
                return true;
            }

            const message = this.$translate.instant('LABEL_TIP_MINIMUM', { tipTypes, totalMinimumTip: formattedTotalMinimumTip });
            this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate, true);
            return false;
        }

        // following is used by tipModal.template.html

        isTipCardOnFile() {
            return this.parent.modalType === RegisterModalTypeEnum.TipCardOnFile;
        }

        ticketPercentageBlur() {
            if (this.ticketPercentageChanged) {
                this.applyTipPercentage(this.ticketPercentage);
                this.ticketPercentageChanged = false;
            }
        }

        ticketAmountBlur() {
            if (this.ticketAmountChanged) {
                this.applyTipAmount(this.ticketAmount);
                this.ticketAmountChanged = false;
            }
        }

        showSpecificTip(showSpecific: boolean) {
            this.specificTip = showSpecific;
        }

        changeTipSymbol(isPercentageSymbol: boolean) {
            this.isPercentageSymbol = isPercentageSymbol;

            const serviceTotal = this.getServiceTotal(this.useDiscountedPrice);

            // Update value/percentage to most current whenever toggle is switched
            if (this.isPercentageSymbol) {
                if (this.ticketAmount !== null) {
                    // if true (selected %), then update % from dollar amount
                    let ticketPercentage = serviceTotal > 0 ? this.ticketAmount / serviceTotal : 0;
                    this.setTicketPercentage(ticketPercentage || 0);
                    this.ticketAmount = null;
                }
            } else {
                if (this.ticketPercentage !== null) {
                    // if false (selected $), then update $ from percentage
                    let ticketAmount = this.ticketPercentage * serviceTotal;
                    this.setTicketAmount(ticketAmount || 0);
                    this.ticketPercentage = null;
                }
            }

            this.refreshTips();
        }

        ticketPercentageChange() {
            this.ticketPercentageChanged = true;
            this.tipLineChanged = true;
        }

        ticketAmountChange() {
            this.ticketAmountChanged = true;
            this.tipLineChanged = true;
        }

        // Have this so that don't unnecessarily refresh tips onblur if nothing has changed
        tipLineChange() {
            this.tipLineChanged = true;
        }

        tipPercentageBlur(tipLine: RegisterTipLine) {
            if (this.tipLineChanged) {
                this.setTicketPercentage(null);
                this.setTicketAmount(null);
                tipLine.amount = 0;
                this.refreshTips();
            }
        }

        tipAmountBlur(tipLine: RegisterTipLine) {
            if (this.tipLineChanged) {
                this.setTicketPercentage(null);
                this.setTicketAmount(null);
                tipLine.percentage = 0;
                this.refreshTips();
            }
        }

        applyNoTip() {
            if (!this.checkMinimumTips(0)) {
                return;
            }

            _(this.tipLines).forEach((tipLine: RegisterTipLine) => {
                if (tipLine.isServiceEmployee) {
                    tipLine.amount = 0;
                    tipLine.percentage = 0;
                    tipLine.forcedDisplayValue = this.normalizeDecimalPlaces(tipLine.percentage * 100);
                }
            });

            this.setTicketPercentage(0);
            this.setTicketAmount(0);

            this.distributeTip(0);

            this.refreshTips();
        }

        isNoTip() {
            if (this.ticketAmount === null && this.ticketPercentage === null) {
                return false;
            }

            if (this.ticketAmount > 0 || this.ticketPercentage > 0 ||
                _(this.tipLines).any(tipLine => tipLine.amount - tipLine.prepaidTipMinimum > 0)) {
                return false;
            }

            return true;
        }

        applyTipPercentage(percentage?: number) {
            let newAmount = this.registerTipService.getSaleLineTipAmount(this.parent.registerContext, percentage, this.nonRefundTipLines, this.useDiscountedPrice);

            this.setTicketPercentage(percentage || 0);
            this.setTicketAmount(newAmount);

            this.distributeTip(newAmount);

            this.refreshTips();
        }

        applyTipAmount(newAmount: number) {
            if (!this.checkMinimumTips(newAmount)) {
                return;
            }

            this.setTicketAmount(newAmount || 0);

            this.distributeTip(newAmount);

            this.refreshTips();
        }

        applyTip() {
            // If clicking apply button when amount field is focused, the dialog will close before
            // the calculated amount can be return from api call, so need to wait for that to be
            // returned and call apply then
            if (this.tipLineChanged) {
                this.needToApplyTip = true;
                return null;
            }

            this.needToApplyTip = false;

            if (this.isForcedTip() &&
                this.totalTipFromPrepaid > this.currentTip) {
                this.showToast("MESSAGE_TIP_LESS_THAN_FORCED_TIP");
                return null;
            }

            if (_(this.tipLines).any(tipLine => tipLine.amount < tipLine.prepaidTipMinimum)) {
                this.showToast("MESSAGE_TIP_LESS_THAN_PREPAID_MINIMUM");
                return null;
            }

            if ((this.parent.modalType === RegisterModalTypeEnum.TipChangeDue || this.parent.modalType === RegisterModalTypeEnum.TipChangeDueTransactionEditor) && this.changeDue > 0 && this.changeRemaining < 0) {
                this.showToast("MESSAGE_TIP_EXCEEDS_CHANGE_DUE");
                return null;
            }

            if (this.tipLines.length > 0 && _(this.tipLines).all(tipLine => tipLine.amount === 0)) {
                this.hasTippyTipLines().then((isTippy) => this.updateSaleTipState(true, isTippy));
            } else {
                this.updateSaleTipState(true);
            }

            return this.parent.closeModal();
        }

        hasTippyTipLines(): ng.IPromise<boolean> {
            if (!this.parent.registerContext || !this.parent.registerContext.tippyService) {
                return this.parent.$q.resolve(false);
            }

                return this.parent.registerContext.tippyService.getTippyEmployeeMappings().then(mappings => {
                    if (mappings.length < 1) {
                        return false;
                    }

                    const tipLineEmployeeIds = _(this.tipLines).pluck('employeeId');
                    return _(_(mappings).pluck('meevoEmployeeId')).any(empId => _(tipLineEmployeeIds).contains(empId));
                });
        }

        clearTips() {
            _(this.tipLines).forEach((tipLine: RegisterTipLine) => {
                tipLine.amount = tipLine.prepaidTipMinimum;
                tipLine.percentage = 0;
            });

            this.setTicketAmount(null);
            this.setTicketPercentage(null);

            this.refreshTips();
        }

        deleteEmployee(tipLineIndex: number) {
            this.tipLines.splice(tipLineIndex, 1);
            this.buildExcludedEmployeeIds();
            this.updateSaleTipState();
            this.refreshTips();
        }

        employeeChanged(tipLine: RegisterTipLine) {
            this.showNewEmp = false;

            if (!tipLine.employee) {
                return;
            }

            if (!tipLine.employeeId) {
                tipLine.employeeId = tipLine.employee.id;
            }

            if (!tipLine.originalEmployee) {
                // user added a new employee
                tipLine.originalEmployee = tipLine.employee;
            }

            if (!tipLine.originalEmployeeId) {
                tipLine.originalEmployeeId = tipLine.originalEmployee.id;
            }

            this.addTipLine(tipLine.employee.id, tipLine.employee, tipLine.originalEmployeeId, tipLine.originalEmployee);

            this.buildExcludedEmployeeIds();
        }

        showNewEmployeeLine(tipLine) {
            this.showNewEmp = true;
            if (tipLine) {
                tipLine.employee = undefined;
                tipLine.originalEmployee = undefined;
                tipLine.employeeId = undefined;
                tipLine.originalEmployeeId = undefined;
            }
        }

        checkCanClose() {
            this.parent.closeModal(true);
        }

        remainingForcedTip(): number {
            const forcedTip = this.totalTipFromPrepaid;
            return Math.max(0, this.parent.registerContext.subtractNormalizedNumbers(forcedTip, this.currentTip));
        }

        deleteRefund(index: number) {
            this.refundTipLines.splice(index, 1);
        }

        isTipFromDevice(): boolean {
            return this.totalTipFromDevice > 0;
        }

        isTipFromPrepaid(): boolean {
            return this.totalTipFromPrepaid > 0;
        }

        isEnteredTip(): boolean {
            return this.isTipFromDevice() || this.isTipFromPrepaid();
        }

        isForcedTip(): boolean {
            return this.isTipFromPrepaid();
        }

        getServiceTotal(useDiscountedPrice: boolean): number {
            return this.registerTipService.getServiceTotal(this.parent.registerContext, this.nonRefundTipLines, useDiscountedPrice);
        }

        toggleDiscountedTotal() {
            // recalculate service totals & re-apply any existing ticket-level automatic tip
            if (this.isPercentageSymbol) {
                if (this.ticketPercentage) {
                    this.applyTipPercentage(this.ticketPercentage);
                    return;
                }
            } else {
                if (this.ticketAmount) {
                    this.applyTipAmount(this.ticketAmount);
                    return;
                }
            }
            this.refreshTips();
        }

        isSaleDiscounted(sale: Meevo.Model.Sale): boolean {
            const serviceSaleLines = _(sale.saleLines).where({ saleType: Meevo.Model.SalesTypeEnum.Service });
            const isSaleLineDiscounted = _(serviceSaleLines).any((saleLine: Meevo.Model.SaleLine) => this.registerTipService.isSaleLineDiscounted(saleLine));
            const isPriceSame = _(this.tipLines).all(tipLine => tipLine.baseTotal == tipLine.finalTotal);
            return isSaleLineDiscounted && !isPriceSame;
        }

        private normalizeDecimalPlaces(input: number) {
            return this.parent.registerContext.normalizeDecimalPlaces(input);
        }

        private getTotalExternalTip(): number {
            return this.normalizeDecimalPlaces(this.externalTipLines.reduce((total, next) => total += next.amount, 0));
        }

        hideDeleteEmployee(tipLine) {
            return tipLine.isServiceEmployee && (tipLine.employee !== this.parent.registerContext.HouseEmployee || !this.showDeleteIconForHouse);
        }

        //test area
        testAll() {
            this.testTippy(1);
            this.testTippy(2);
            this.testTippy(3);
            this.testTippy(4);
        }
        testTippy(testType: number = 1, useModalValues: boolean = false) {
            // run this from console with meevo Register tab open and Tip Modal open [for testType see test cases]:
            // angular.element('*[ng-app]').scope().$$childTail.vm.context.testTippy(1)  //use second parameter as true if want to evaluate Employees in Modal

            const generateSaleLine = (
                saleType,
                employee1Id,
                employee1Percent,
                employee1AllowTips,
                employee2Id,
                employee2Percent,
                employee2AllowTips,
                baseItemPriceCharge,
                finalItemPriceCharge,
                prepaidTipRedeemed,
                serviceAllowTips,
                quantity: number = 1
            ): Model.SaleLine => {
                let saleLine = {
                    saleType: saleType,
                    quantity: quantity,
                    employeeId: employee1Id,
                    employeeSplitCommission: employee1Percent,
                    employee: {
                        id: employee1Id,
                        allowTips: employee1AllowTips,
                    },
                    secondEmployeeId: employee2Id,
                    secondEmployee: employee2Id ? {
                        id: employee2Id,
                        allowTips: employee2AllowTips,
                    } : null,
                    secondEmployeeSplitCommission: employee2Percent,
                    baseItemPriceCharge: baseItemPriceCharge,
                    finalItemPriceCharge: finalItemPriceCharge,
                    basePriceCharge: baseItemPriceCharge * quantity,
                    finalPriceCharge: finalItemPriceCharge * quantity,
                    prepaidTipRedeemed: prepaidTipRedeemed,
                    discountLines: [],
                } as Model.SaleLine;

                switch (saleType) {
                    case Meevo.Model.SalesTypeEnum.Service:
                        saleLine.item = {
                            doNotAllowTips: !serviceAllowTips
                        };
                        break;
                    case Meevo.Model.SalesTypeEnum.PackageServiceSwapFee:
                        saleLine.item = {
                            id: '00000000-0000-0000-0000-000000000001'
                        }
                        break;
                }

                return saleLine;
            }

            const expectedTipLine = (
                employeeId,
                originalEmployeeId,
                serviceTotal,
                isServiceEmployee,
                amount,
                percentage,
                prepaidTipMinimum
            ) => ({
                amount: amount,
                employee: null,
                employeeId: employeeId,
                isRefund: false,
                isServiceEmployee: isServiceEmployee,
                originalEmployee: null,
                originalEmployeeId: originalEmployeeId,
                //serviceTotal: serviceTotal,
                percentage: percentage,
                //prepaidTipMinimum: prepaidTipMinimum
            });

            const generateTest = (
                tipPercentage: number,
                tipAmount: number,
                useDiscountedPrice: boolean,
                includeProductsInTips: boolean,
                saleLines: Model.SaleLine[],
                expectedTipLines: Model.TipLine[],
                desc: string,
            ) => {
                return {
                    tipPercentage: tipPercentage,
                    tipAmount: tipAmount,
                    useDiscountedPrice: useDiscountedPrice,
                    includeProductsInTips: includeProductsInTips,
                    desc: desc,
                    sale: {
                        saleLines: saleLines,
                    },
                    tipLines: [] as Model.TipLine[],
                    expected: expectedTipLines,
                };
            };

            const S = Model.SalesTypeEnum.Service;
            const P = Model.SalesTypeEnum.Product;
            const U = Model.SalesTypeEnum.PackageServiceSwapFee;

            const H = '00000000-0000-0000-0000-000000000000';
            const E1 = 'EEEEEEEE-0001-0000-0000-000000000000';
            const E2 = 'EEEEEEEE-0002-0000-0000-000000000000';
            const E3 = 'EEEEEEEE-0003-0000-0000-000000000000';

            /*testcases -> need to open modal and perform following
            1. 1 Service Employee with tip amount > 0.00 + 1 manually added with tip amount = 0.00 ==> Service Employee + Manualy added Employee Tip Line are in sale.tipLines
            2. 1 Service Employee with tip amount = 0.00 + 1 manually added with tip amount = 0.00 ==> Only manually added Employee tip line is in sale.tipLines
            3. 1 Service Employee with tip amount > 0.00 + 1 manually added with tip amount = 0.00, then remove Sale Line with Service Employee (from Register)
                ==> Only manually added Employee tip line is in sale.tipLines
            4. 2 Service Employees with tip amount > 0.00 + 1 manually added with tip amount = 0.00, then remove 1 Sale Line with first Service Employee (from Register)
                ==> 2nd Service Employee + Manualy added Employee Tip Line are in sale.tipLines
            */

            var saleTipLines: Model.TipLine[] = [];
            if (!useModalValues) {
                this.tipLines = [];
                //this.tipLines.push(expectedTipLine(E1, E1, /*service-total*/ 10, /*amount*/ 0, /*isServiceEmployee*/ 1,/*percent*/ null, /*prepaidTipMinimum*/ 0));
            }
            switch (testType) {
                case 1:
                    this.addTipLine(E1, null, E1, null, /*amount*/ 10, null, 0, 0, /*isServiceEmployee*/ true);
                    this.addTipLine(E2, null, E2, null, /*amount*/ 0, null, 0, 0, /*isServiceEmployee*/ false);
                    saleTipLines = this.updateSaleTipState(false);
                    var result1 = _(saleTipLines).findWhere({ employeeId: E1 });
                    var result2 = _(saleTipLines).findWhere({ employeeId: E2 });
                    if (result1 && result2) {
                        console.error('1. 1 Service Employee with tip amount > 0.00 + 1 manually added with tip amount = 0.00', '✅');
                    }
                    else {
                        console.error('1. 1 Service Employee with tip amount > 0.00 + 1 manually added with tip amount = 0.00', '❌');
                    }

                    //test = generateTest(null, 0, true, false, [
                    //    generateSaleLine(S, /*emp1*/ E1, 1, true, /*emp2*/ null, 0, true,  /*base*/ 60, /*final*/ 40, /*prepaid*/ 0,   /*service-tip*/ true),
                    //],
                    //[
                    //    expectedTipLine(E1, E1, /*service-total*/ 10, /*amount*/ 0, /*isServiceEmployee*/ 1,/*percent*/ null, /*prepaidTipMinimum*/ 0),
                    //    expectedTipLine(E2, E2, /*service-total*/  0, /*amount*/ 0, /*isServiceEmployee*/ 0,/*percent*/ null, /*prepaidTipMinimum*/ 0),
                    //], 'description');
                    break;
                case 2:
                    this.addTipLine(E1, null, E1, null, /*amount*/ 0, null, 0, 0, /*isServiceEmployee*/ true);
                    this.addTipLine(E2, null, E2, null, /*amount*/ 0, null, 0, 0, /*isServiceEmployee*/ false);
                    saleTipLines = this.updateSaleTipState(false);
                    var result1 = _(saleTipLines).findWhere({ employeeId: E1 }); //should be removed
                    var result2 = _(saleTipLines).findWhere({ employeeId: E2 });
                    if (!result1 && result2) {
                        console.error('2. 1 Service Employee with tip amount = 0.00 + 1 manually added with tip amount = 0.00', '✅');
                    }
                    else {
                        console.error('2. 1 Service Employee with tip amount = 0.00 + 1 manually added with tip amount = 0.00', '❌');
                    }
                    break;
                case 3:
                    this.addTipLine(E1, null, E1, null, /*amount*/ 10, null, 0, 0, /*isServiceEmployee*/ true);
                    this.addTipLine(E2, null, E2, null, /*amount*/ 0, null, 0, 0, /*isServiceEmployee*/ false);
                    saleTipLines = this.updateSaleTipState(false);
                    this.tipLines.splice(0, 1); //registerContext removes TipLine for the Servicing Employee through recalculate/API call, so mocking it directly
                    saleTipLines = this.updateSaleTipState(false);
                    var result1 = _(saleTipLines).findWhere({ employeeId: E1 }); //should be removed
                    var result2 = _(saleTipLines).findWhere({ employeeId: E2 });
                    if (!result1 && result2) {
                        console.error('3. 1 Service Employee with tip amount > 0.00 + 1 manually added with tip amount = 0.00, then remove Sale Line with Service Employee', '✅');
                    }
                    else {
                        console.error('3. 1 Service Employee with tip amount > 0.00 + 1 manually added with tip amount = 0.00, then remove Sale Line with Service Employee', '❌');
                    }
                   break;
                case 4:
                    this.addTipLine(E1, null, E1, null, /*amount*/ 10, null, 0, 0, /*isServiceEmployee*/ true);
                    this.addTipLine(E2, null, E2, null, /*amount*/ 12, null, 0, 0, /*isServiceEmployee*/ true);
                    this.addTipLine(E3, null, E3, null, /*amount*/ 0, null, 0, 0, /*isServiceEmployee*/ false);
                    saleTipLines = this.updateSaleTipState(false);
                    this.tipLines.splice(1, 1); //registerContext removes TipLine for the Servicing Employee through recalculate/API call, so mocking it directly
                    saleTipLines = this.updateSaleTipState(false);
                    var result1 = _(saleTipLines).findWhere({ employeeId: E1 });
                    var result2 = _(saleTipLines).findWhere({ employeeId: E2 }); //should be removed
                    var result3 = _(saleTipLines).findWhere({ employeeId: E3 });
                    if (result1 && !result2 && result3) {
                        console.error('3. 2 Service Employees with tip amount > 0.00 + 1 manually added with tip amount = 0.00, then remove 1 Sale Line with first Service Employee', '✅');
                    }
                    else {
                        console.error('3. 2 Service Employees with tip amount > 0.00 + 1 manually added with tip amount = 0.00, then remove 1 Sale Line with first Service Employee', '❌');
                    }
                    break;

            }

        }

    }
}